import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import QuoteProps from '../../models/Quote/QuotePropTypes';
import { Container, TitleSet, InternalLink } from '../../ui-components';
import QuoteCarouselLegacy from '../quote-carousel-legacy';

const propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  linkUrl: PropTypes.string,
  linkLabel: PropTypes.string,
  testimonials: PropTypes.arrayOf(QuoteProps),
  sectionTitle: PropTypes.string,
};

/**
 * Component that renders quote carousel section with a title, subTitle, and CTA
 *
 * @component SectionTestimonial
 * 
 * @param {object} props
 * 
 * @prop {string} title
 * @prop {string} subTitle
 * @prop {string} linkUrl
 * @prop {string} linkLabel
 * @prop {array} testimonials
 * @prop {string} sectionTitle
 * 
 * @return {JSX}
 */
const SectionTestimonial = props => {
  const { title, subTitle, linkUrl, linkLabel, testimonials, sectionTitle } = props;

  /**
   * Renders the title section above the testimonials if the appropriate properties are available
   *
   * @function renderTitleSection
   * 
   * @returns {JSX}
   */
  const renderTitleSection = () => {
    return (
      <>
        {title && (
          <TitleSection>
            <TitleSet label={sectionTitle} title={title} bodyText={subTitle} />
          </TitleSection>
        )}
      </>
    );
  };

  /**
   * Renders the CTA below the testimonial if the appropriate
   * properties are available
   *
   * @function renderCTA
   * 
   * @returns {JSX}
   */
  const renderCTA = () => {
    return (
      <>
        {linkLabel && linkUrl && (
          <LinkContainer>
            <InternalLink linkstyle="primary-button" to={linkUrl}>
              {linkLabel}
            </InternalLink>
          </LinkContainer>
        )}
      </>
    );
  };

  return (
    <TestimonialContainer sectionContainer>
      {renderTitleSection()}
      <QuoteCarouselLegacy quotes={testimonials} />
      {renderCTA()}
    </TestimonialContainer>
  );
};
const TitleSection = styled.div`
  text-align: center;
`;

const LinkContainer = styled(props => <Container {...props} />)`
  text-align: center;
  padding-top: 36px;
`;

const TestimonialContainer = styled(Container)`
  background-color: ${props => props.backgroundColor};
`;

SectionTestimonial.propTypes = propTypes;

export default SectionTestimonial;
